import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import React from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "../../Component/utils/axiosInstance";

const ForgetEmail = () => {
  const navigate = useNavigate();

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
  });
  const initialValues = {
    email: "",
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const formData = new FormData();
      formData.append("email", values?.email);
      const response = await axiosInstance.post(
        "user/forgot/password",
        formData
      );
      if (response.data.status === true) {
        toast.success(response.data.message || "Please Check Your Email..!");
        navigate("/signin");
      }
    } catch (error) {
      const { message } = error?.response?.data;
      toast.error(message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container" style={{ height: "100vh" }}>
      <div className="row align-items-center h-100">
        <div className="col-lg-5 col-md-6">
          <img
            src="/images/loginImg.png"
            className="img-fluid d-block my-auto"
            alt="Login Illustration"
          />
        </div>

        <div className="col-6 ms-auto">
          <img
            src="/images/registerLogo.png"
            className="w-25 d-block mx-auto pb-4"
            alt="Register Logo"
          />
          <h1 className="fw-bolder text-black fs-2 py-2">Enter Email</h1>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form>
                <label className="fw-bolder text-secondary fs-6 pt-1">
                  Enter Your Email Address
                </label>
                <Field
                  type="email"
                  name="email"
                  className="form-control border-2 border-secondary py-2 fw-semibold"
                  placeholder="hello@example.com"
                />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="text-danger"
                />

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="btn btn-danger w-100 fw-bold py-2 fs-6 mt-4"
                  style={{ background: "#CD2128", border: "none" }}
                >
                  {isSubmitting ? "Submiting..." : "Submit"}
                </button>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default ForgetEmail;
